export enum FormControlValidator {
  AfterDate = 'afterDate',
  Alphabetical = 'alphabetical',
  BeforeDate = 'beforeDate',
  Custom = 'custom',
  Date = 'date',
  Email = 'email',
  IBAN = 'iban',
  Maximum = 'maximum',
  MaximumLength = 'maximumLength',
  Minimum = 'minimum',
  MinimumLength = 'minimumLength',
  Pattern = 'pattern',
  Postcode = 'postcode',
  Required = 'required',
  RestrictedCharacters = 'restrictedCharacters',
  Telephone = 'telephone',
}
